import { siteContentService } from './api';

const SLIDES_KEY = 'SLIDES';

function parseSlides(value) {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

const sliderService = {
  getAll: async () => {
    try {
      const response = await siteContentService.get(SLIDES_KEY);
      return { data: parseSlides(response.data?.value) };
    } catch (error) {
      if (error.response?.status === 404) {
        return { data: [] };
      }
      throw error;
    }
  },

  saveAll: async (slides) => {
    const response = await siteContentService.set(SLIDES_KEY, { value: JSON.stringify(slides) });
    return { data: response.data };
  },

  create: async (slideData) => {
    const existingResponse = await sliderService.getAll();
    const slides = existingResponse.data;
    const newSlide = { id: Date.now(), ...slideData };
    const updated = [...slides, newSlide];
    await siteContentService.set(SLIDES_KEY, { value: JSON.stringify(updated) });
    return { data: newSlide };
  },

  update: async (id, slideData) => {
    const existingResponse = await sliderService.getAll();
    const slides = existingResponse.data;
    const updated = slides.map(s => (s.id === id ? { ...s, ...slideData } : s));
    await siteContentService.set(SLIDES_KEY, { value: JSON.stringify(updated) });
    return { data: { id, ...slideData } };
  },

  delete: async (id) => {
    const existingResponse = await sliderService.getAll();
    const slides = existingResponse.data;
    const updated = slides.filter(s => s.id !== id);
    await siteContentService.set(SLIDES_KEY, { value: JSON.stringify(updated) });
    return { data: { id } };
  }
};

export default sliderService;
